import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import Cookies from 'js-cookie'
import Axios from "axios"
import {layer} from "@layui/layui-vue";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const Service = Axios.create({
  baseURL: "/admin/api",
  timeout: 2000,
  retry: 3
});

Service.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  const config = err.config;
  if (config && config.retry) {
    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= config.retry) {
      return Promise.reject(err);
    }
    config.__retryCount += 1;
    const backoff = new Promise(function(resolve) {
      setTimeout(resolve, config.__retryCount * 1000);
    });
    return backoff.then(function() {
      return Service(config);
    });
  }
  return Promise.reject(err);
});

const routes = [
  { path: '',
    redirect: '/login'},
  {
    path: '/main',
    name: 'home',
    component: HomeView,
    meta:{title: "CourtFlow 网球场馆AI训练数据系统"},
    children:[
      { path: '',
        redirect: '/main/inbox'},
      {
        path: '/main/inbox',
        component: () => import('@/views/Inbox.vue'),
        meta: {title: 'CourtFlow · 数据概览', section: '数据概览'},
      },
      {
        path: '/main/user/',
        component: () => import('@/views/UserList.vue'),
        meta: {title: 'CourtFlow · 学员档案', section: '学员档案', keepAlive: false},
      },
      {
        path: '/main/user/approve',
        component: () => import('@/views/UserReviewList.vue'),
        meta: {title: 'CourtFlow · 账号审核', section: '系统设置 · 账号审核'},
      },
      {
        path: '/main/user/credit',
        component: () => import('@/views/UserUnsignedList.vue'),
        meta: {title: 'CourtFlow · 缺课管理', section: '系统设置 · 缺课管理'},
      },
      {
        path: '/main/action/create',
        component: () => import('@/views/ActionCreate.vue'),
        meta: {title: 'CourtFlow · 新建课程', section: '训练课程 · 新建课程'},
      },
      {
        path: '/main/action',
        component: () => import('@/views/ActionList.vue'),
        meta: {title: 'CourtFlow · 课程管理', section: '训练课程 · 课程管理'},
      },
      {
        path: '/main/records',
        component: () => import('@/views/RecordsList.vue'),
        meta: {title: 'CourtFlow · 学员到课记录', section: '预约与到课 · 学员到课记录'},
      },
      {
        path: '/main/records/worker',
        component: () => import('@/views/WorkRecordsList.vue'),
        meta: {title: 'CourtFlow · 教练授课记录', section: '预约与到课 · 教练授课记录'},
      },
      {
        path: '/main/assessments',
        component: () => import('@/views/IntelligentAssessment.vue'),
        meta: {title: 'CourtFlow · 智能评估', section: '智能评估'},
      },
      {
        path: '/main/assessments/demo',
        component: () => import('@/views/TrainingReview.vue'),
        meta: {title: 'CourtFlow · 训练复盘', section: '智能评估'},
      },
      {
        path: '/main/devices',
        component: () => import('@/views/DevicesData.vue'),
        meta: {title: 'CourtFlow · 设备与数据', section: '设备与数据'},
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta:{title: "CourtFlow · 管理端登录"}
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    meta: {title: 'CourtFlow · 页面不存在'},
    component: () => import('../views/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  NProgress.start();
  if(to.name !== '404') {
    if(to.name !== 'Login' && Cookies.get('token') === undefined) {
      if(from.name !== 'Login' && from.path !== '/'){
        layer.msg( "登录已失效，请重新登录");
      }
      return '/login';
    }
    if(Cookies.get('token') !== undefined){
      try{
        const response = await Service.post('/user/verify?token=' + Cookies.get('token'));
        if(response.status !== 200){
          layer.msg("账号状态已变更，请重新登录");
          Cookies.remove('token');
          return '/login';
        }
        if(response.data.status <= 0){
          layer.msg("账号状态已变更，请重新登录");
          Cookies.remove('token');
          return '/login';
        }
        if(to.name === 'Login' && response.data.status > 0)
          return '/main';
      }
      catch (error) {
        layer.msg("网络连接失败，请重新登录", {icon: 2});
        Cookies.remove('token');
        if (to.name !== 'Login') return '/login';
      }
    }
  }
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  return true;
});

router.afterEach(() => {
  NProgress.done();
});

router.Axios = Service;
export default router
